module.exports = __webpack_public_path__ + "img/shutterstock_228844615.de9d8efd.jpg";